<template>
  <div class="quote-header">
    <div class="quote-header__title">
      <OrganisationV2Icon :fill="skWhite" />
      <span class="sk-heading-small-semibold">{{ organisationName }}</span>
    </div>
    <div class="quote-header__quote-number">
      <span class="sk-text-medium-regular">
        {{ $t('quote_details_unique_pricing.quote_number') }}
      </span>
      <span class="sk-text-medium-semibold">#{{ quoteNumber }}</span>
    </div>
  </div>
</template>

<script>
import { SK_COLORS } from '@skelloapp/skello-ui';

export default {
  name: 'QuoteHeader',
  props: {
    organisationName: {
      type: String,
      required: true,
    },
    quoteNumber: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      skWhite: SK_COLORS.skWhite,
    };
  },
};
</script>

<style lang="scss">
@use './shared' as *;

.quote-header {
  flex: 1;
  display: flex;
  gap: 16px;
  padding: 24px 16px;
  align-items: center;
  border-radius: 8px;
  background-color: $sk-blue;
  color: $sk-white;
}

.quote-header__title {
  flex: 1;
  display: flex;
  gap: 16px;
  align-items: flex-start;

  svg {
    flex-shrink: 0;
  }
}

.quote-header__quote-number {
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  text-align: right;
}
</style>
